const searchNoFiltersMessage = 'We couldn’t find anything by\n your request, try to change the query!';

export const libraryNoDataDescriptions = {
  noData: 'Create your first note to\n get started or take the guide!',
  searchNoFilters: searchNoFiltersMessage,
  searchHasFilters: 'We couldn’t find anything by\n your request, try to change the query or filters!',
};

export const cortexNoDataDescriptions = {
  noData: 'Create your first Cortex item to\n include in a note for AI to learn!',
  searchNoFilters: searchNoFiltersMessage,
};

export const tagsNoDataDescriptions = {
  noData: 'Create a tag, give it a name and color!\n Assign a tag to any item to find them quickly!',
  searchNoFilters: searchNoFiltersMessage,
};
